import api from '../../api/nodeBackApi';


export const getCustomerWithCamaras = async (customerId) => {
  try {
    const response = await api.get(`/api/customerDashboard/getall`);
    return response.data;
  } catch (error) {
    console.error("Error fetching customer cameras:", error);
    throw error;
  }
}